<template>
    <Modal title="Modificar Cliente" name="modal" v-model="cliente.editar" :enableClose="false" :modal-style="{'min-width': '300px', 'max-width': '650px'}">
        
        <div class="vm-content">
            <CRow>
                <CCol col="7">
                    <div v-show="cliente.editar">
                        <CInput
                            size="sm"
                            label="Rut Cliente"
                            v-model="cliente.rutEmpresa"
                            type="text"
                            horizontal
                            placeholder="Rut Cliente"
                        />
                    </div>
                    <div v-show="cliente.editar">
                        <CInput
                            size="sm"
                            label="Nombre Cliente"
                            v-model="cliente.nombreCliente"
                            type="text"
                            horizontal
                            placeholder="Nombre Cliente"
                        />
                    </div>
                    
                    <div v-show="cliente.editar"
                        v-tippy="getBaseTippy('Carpeta en donde se encuetra la Ruta del cliente en el FileServer ej:(Vapp, SoloEdig, etc.)')"
                    >
                        <CInput
                            size="sm"
                            label="Carpeta Raiz BD"
                            v-model="cliente.carpetaRaiz"
                            type="text"
                            horizontal
                            placeholder="Carpeta Raiz BD"
                        />
                    </div>

                    <div v-show="cliente.editar"
                        v-tippy="getBaseTippy('Nombre de la carpeta del cliente, ej: (NombreCliente$')"
                        >
                        
                        <CInput
                            size="sm"
                            label="ruta Carpeta BD"
                            v-model="cliente.rutaCarpetaBd"
                            type="text"
                            horizontal
                            placeholder="Ruta Carpeta Bd"
                        />
                    </div>
                    <div v-show="cliente.editar"
                        v-tippy="getBaseTippy('Id de la unidad que se crea en Google Drive  <hr><div> se encuentra deshabilitada para no equivocarse y cambiarla sin querer</div>')"
                    >
                        
                        <CInput :disabled="!cliente.habilitarGesto || !modificarIdUnidad"
                            size="sm"
                            label="id Unidad Drive"
                            v-model="cliente.idUnidadDrive"
                            type="text"
                            horizontal
                            placeholder="Id Unidad Drive"
                        /> 
                    </div>
                    
                    <div v-show="cliente.editar"
                        v-tippy="getBaseTippy('Nombre de la unidad que se crea en Google Drive  <hr><div> se encuentra deshabilitada para no equivocarse y cambiarla sin querer</div>')"
                    >
                        <CInput :disabled="!cliente.habilitarGesto || !modificarNombreUnidadDrive"
                            size="sm"
                            label="Nombre Unidad Drive"
                            v-model="cliente.rutaCarpetaDrive"
                            type="text"
                            horizontal
                            placeholder="Carpeta Defecto Drive"
                        />
                    </div>

                    <div v-show="cliente.editar"
                        v-tippy="getBaseTippy('Carpeta que por defecto se almacena toda la info de gesto en Google Drive (se usa --Reportes--, no cambiar por ahora) <hr><div> se encuentra deshabilitada para no equivocarse y cambiarla sin querer</div>')"
                        >
                        <CInput :disabled="!cliente.habilitarGesto || !modificarCarpetaDriveDefecto"
                            size="sm"
                            label="Carpeta Defecto Drive"
                            v-model="cliente.carpetaDefectoDrive"
                            type="text"
                            horizontal
                            placeholder="Carpeta Defecto Drive"
                        />
                    </div>
                    <div v-show="cliente.editar && cliente.habilitarGesto"
                    v-tippy="getBaseTippy('CUIDADO! <hr>Recomendamos no modificar estas variables. Si están vacías y se habilita por primera vez Gesto o Compartida, se llenarán automáticamente. En el caso de que se haya modificado algún dato en Google Drive, se deberán ajustar, de lo contrario, no tocarlas. Gracias. <hr>Recuerda --Un gran poder conlleva una gran responsabilidad--')"
                        >
                        
                        <CSwitch
                            
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="modificarVariablesDrive"
                            @update:checked="modificarVariablesDrive = !modificarVariablesDrive; modificarIdUnidad = !modificarIdUnidad; modificarNombreUnidadDrive = !modificarNombreUnidadDrive; modificarCarpetaDriveDefecto = !modificarCarpetaDriveDefecto;"
                        /> Editar variables Drive
                    </div>
                </CCol>
                <CCol col="5">
                    <div v-show="cliente.editar">
                       
                        <CSwitch
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.habilitado"
                            @update:checked="cliente.habilitado = !cliente.habilitado"
                        />  Habilitar Cliente
                    </div>
                    <div>
                        
                        <CSwitch
                            v-tippy="getBaseTippy((cliente.habilitarGesto)?'Deshabilitar Gesto':'Habilitar Gesto')"
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.habilitarGesto"
                            @update:checked="cliente.habilitarGesto = !cliente.habilitarGesto"
                        /> Habilitar Gesto 
                    </div>
                    <div>
                        <CSwitch
                            v-tippy="getBaseTippy((cliente.habilitarCompartida)?'Deshabilitar Compartida archivos':'Habilitar Compartida archivos')"
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.habilitarCompartida"
                            @update:checked="cliente.habilitarCompartida = !cliente.habilitarCompartida"
                        /> Habilitar Compartida
                    </div>
                    <div>
                        <CSwitch
                            :disabled="!cliente.habilitarGesto"
                            v-tippy="getBaseTippy((cliente.habilitarCompartida)?'Deshabilitar Portal Empresa':'Habilitar Portal Empresa')"
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.habilitadoPortalEmpresa"
                            @update:checked="cliente.habilitadoPortalEmpresa = !cliente.habilitadoPortalEmpresa"
                        />Habilitar Portal Empresa
                    </div>

                    <hr>
                    
                    <div>
                        <CSwitch
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.tipoBdRemu"
                            @update:checked="cliente.tipoBdRemu = !cliente.tipoBdRemu"
                        /> Remu
                    </div>
                    <div>
                        <CSwitch
                            v-show="cliente.editar"
                            width="150px"
                            class="mx-1 align-middle mb-2" 
                            color="success" 
                            shape="pill"
                            variant="outline"
                            v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                            :checked="cliente.tipoBdConta"
                            @update:checked="cliente.tipoBdConta = !cliente.tipoBdConta"
                        /> Conta
                    </div>

                </CCol>
            </CRow>
            
        </div>
        <div class="vm-footer">
            <CButtonGroup class="mx-1" v-show="cliente.editar">
                <CButton 
                    :disabled="isModificando"
                    color="success" size="sm" 
                    :content="'Aceptar Cambios'"                                            
                    v-tippy="{ 
                        placement: 'top',
                        arrow: true, 
                        arrowType: 'round', 
                        animation:'fade',
                        theme: 'google',
                        followCursor : true,
                    }"                                          
                    @click="guardarEdicionCliente(cliente)">
                    <CIcon name="cil-check-circle"/>
                </CButton>
                <CButton
                    :disabled="isModificando"
                    color="danger" size="sm"
                    :content="'Cancelar Cambios'"                                            
                    v-tippy="{ 
                        placement: 'top',
                        arrow: true, 
                        arrowType: 'round', 
                        animation:'fade',
                        theme: 'google',
                        followCursor : true,
                    }"
                    @click="cliente.editar=false; cancelarEdicion(cliente)">
                    <CIcon name="cil-x-circle"/>
                </CButton>
                <CButton color="warning" size="sm" v-show="isModificando">
                    <CIcon :content="$options.freeSet.cilLoopCircular" class="imgr" />
                </CButton>
            </CButtonGroup>
        </div>
</Modal>
</template>

<script>

    import cons from "@/const";
    
    import axios from "axios";
    import VueModal from "@kouts/vue-modal";
    import "@kouts/vue-modal/dist/vue-modal.css";
    
    import { freeSet } from "@coreui/icons";
    import { CCol } from "@coreui/vue";

    export default {
        name: "EditarCliente",
        freeSet,
        props: {
            cliente: Object
        },
        components: {
            Modal: VueModal,
        },
        data() {
            return {
                tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin")).tokenUsuario,
                baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,

                isModificando: false,

                modificarVariablesDrive: false,
                modificarIdUnidad: false,
                modificarNombreUnidadDrive: false,
                modificarCarpetaDriveDefecto: false
            }
        },
        created: function () {},
        beforeMount() {
        },
        mounted() {},
        methods: {
            guardarEdicionCliente: function(){
                this.isModificando = true
                let clienteMod = {
                    idCliente: this.cliente.idCliente,
                    nombreCliente: this.cliente.nombreCliente,
                    rutEmpresa: this.cliente.rutEmpresa,
                    rutaCarpetaBd: this.cliente.rutaCarpetaBd,
                    idUnidadDrive: this.cliente.idUnidadDrive,
                    habilitado: this.cliente.habilitado,
                    habilitadoGesto: this.cliente.habilitarGesto,
                    habilitadoCompartida: this.cliente.habilitarCompartida,
                    rutaCarpetaDrive: this.cliente.rutaCarpetaDrive,
                    carpetaDefectoDrive: this.cliente.carpetaDefectoDrive,
                    habilitadoPortalEmpresa: this.cliente.habilitadoPortalEmpresa,
                    carpetaRaiz: this.cliente.carpetaRaiz,
                    tipoBdRemu: this.cliente.tipoBdRemu,
                    tipoBdConta: this.cliente.tipoBdConta
                }
                var url = this.baseUrl + "/modificar_cliente/";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "clienteData": clienteMod
                    },
                    "headers": {
                        'Authorization': this.tokenLogin
                    }
                }).then(result => {
                    this.mostrarNotificaciones2(4, "Notificación!", result.data.mensajeGeneral, 'bottom-center')
                    if("mensajes" in result.data){
                        result.data.mensajes.forEach(msj => this.mostrarNotificaciones2(4, "Notificación!", msj, 'bottom-right'))
                    }
                    //this.mostrarNotificaciones(1, result.data)
                    //this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});
                    
                    this.cliente.editar = false
                    this.cliente.idCliente = clienteMod.idCliente,
                    this.cliente.nombreCliente = clienteMod.nombreCliente,
                    this.cliente.rutEmpresa = clienteMod.rutEmpresa,
                    this.cliente.rutaCarpetaBd = clienteMod.rutaCarpetaBd,
                    this.cliente.idUnidadDrive = clienteMod.idUnidadDrive,
                    this.cliente.habilitado = clienteMod.habilitado,
                    this.cliente.habilitadoGesto = clienteMod.habilitadoGesto,
                    this.cliente.habilitadoCompartida = clienteMod.habilitadoCompartida,
                    this.cliente.rutaCarpetaDrive = clienteMod.rutaCarpetaDrive,
                    this.cliente.carpetaDefectoDrive = clienteMod.carpetaDefectoDrive,
                    this.cliente.habilitadoPortalEmpresa = clienteMod.habilitadoPortalEmpresa,
                    this.cliente.carpetaRaiz = clienteMod.carpetaRaiz,
                    this.cliente.tipoBdRemu = clienteMod.tipoBdRemu,
                    this.cliente.tipoBdConta = clienteMod.tipoBdConta
                    
                }, error => {
                        let mensaje = `Problema al modificar Cliente, ${error}`
                        this.mostrarNotificaciones(2, error.response.data)
                       
                })
                .finally(() => {
                    this.isModificando = false
                });
            },
            cancelarEdicion: function(cliente){
                this.modificarVariablesDrive = false,
                this.modificarIdUnidad = false,
                this.modificarNombreUnidadDrive = false,
                this.modificarCarpetaDriveDefecto = false
                cliente.nombreCliente = cliente.respaldocliente.nombreCliente
                cliente.rutEmpresa = cliente.respaldocliente.rutEmpresa
                cliente.rutaCarpetaBd = cliente.respaldocliente.rutaCarpetaBd
                cliente.idUnidadDrive = cliente.respaldocliente.idUnidadDrive
                cliente.habilitado = cliente.respaldocliente.habilitado
                cliente.habilitarGesto = cliente.respaldocliente.habilitarGesto,
                cliente.habilitarCompartida = cliente.respaldocliente.habilitarCompartida
                cliente.rutaCarpetaDrive = cliente.respaldocliente.rutaCarpetaDrive
                cliente.carpetaDefectoDrive = cliente.respaldocliente.carpetaDefectoDrive
                cliente.habilitadoPortalEmpresa = cliente.respaldocliente.habilitadoPortalEmpresa
                cliente.carpetaRaiz = cliente.respaldocliente.carpetaRaiz
                
                cliente.tipoBdRemu =  cliente.respaldocliente.tipoBdRemu
                cliente.tipoBdConta =  cliente.respaldocliente.tipoBdConta

            },
        }
    }
</script>